module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    General\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menuItemsWithPermissions()), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.prefix) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.prefix)
      }
    }) : _vm._e(), _vm._v(" "), (item.path) ? _c('router-link', {
      attrs: {
        "to": {
          name: item.name,
          params: item.params
        },
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.expandMenu(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['mdi', item.meta.icon]
    })]), _vm._v("\n        " + _vm._s(item.meta.label || item.name) + "\n        "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "mdi mdi-chevron-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.expandMenu(item)
        }
      }
    }, [_c('div', {
      staticClass: "columns is-variable is-1"
    }, [_c('div', {
      staticClass: "column is-narrow"
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['mdi', item.meta.icon]
    })])]), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_vm._v("\n            " + _vm._s(item.meta.label || item.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "column is-narrow"
    }, [(item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "mdi mdi-chevron-down"
    })]) : _vm._e()])])]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((_vm.childrenWithPermissions(item)), function(subItem, index) {
      return _c('li', {
        key: index
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: subItem.name,
            params: item.params
          },
          "exact": ""
        }
      }, [_vm._v("\n              " + _vm._s(subItem.meta.label || subItem.name) + "\n            ")])], 1)
    }), 0)]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bb1b601"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 285
// module chunks = 11